export default __webpack_public_path__ + "static/media/Banner12.07fa2d5e.jpg";